import { type FC, type ReactNode, type SyntheticEvent } from 'react';

import { Link, WrapElementsSpacer } from '@/packages/shared-ui';

import styles from './SpecialGeo.css';

type SpecialGeoProps = {
  url: string;
  name: string;
  icon: ReactNode;
  remoteness: string;
  remotenessIcon: ReactNode;
  trackClick(): void;
  onClick?(e: SyntheticEvent<HTMLElement>): void;
};

export const SpecialGeo: FC<SpecialGeoProps> = props => {
  const { icon, name, url, remoteness, remotenessIcon, onClick, trackClick } = props;

  return (
    <div className={styles['container']}>
      <WrapElementsSpacer horizontalSpace={4} verticalSpace={0} wrapItems={false}>
        {icon}
        <Link behaviour="hover_black_to_primary" href={url} track={trackClick} onClick={onClick}>
          <span className={styles['special-geo-name']} data-testid="card.special-geo.name">
            {name}
          </span>
        </Link>
      </WrapElementsSpacer>
      <WrapElementsSpacer horizontalSpace={4} verticalSpace={0} wrapItems={false}>
        {remotenessIcon}
        <span data-testid="card.special-geo.remoteness">{remoteness}</span>
      </WrapElementsSpacer>
    </div>
  );
};
